var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlutenFreeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.121,
    height: 66.398,
    viewBox: "0 0 64.121 66.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1-gluten-free{fill:none;stroke:#e5b515;stroke-miterlimit:10;stroke-width:3px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glten-Icon",
    transform: "translate(1.061 1.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_102",
    d: "M62 0L0 62",
    className: "cls-1-gluten-free",
    transform: "translate(0 .626)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    transform: "translate(12.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    d: "M318.7 107.507c-1.517-6.629-7.133-8.508-16.4-8.508-.006 8.59 4.327 11.72 12.462 12.441",
    className: "cls-1-gluten-free",
    transform: "translate(-302.308 -79.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    d: "M309.733 117.609a13.485 13.485 0 0 1-1.868-7.609 34.509 34.509 0 0 1 8.6.874",
    className: "cls-1-gluten-free",
    transform: "translate(-307.865 -74.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    d: "M296 95.223C296 88.684 301.609 85 301.609 85s5.609 3.684 5.609 10.223-5.609 10.812-5.609 10.812S296 101.763 296 95.223z",
    className: "cls-1-gluten-free",
    transform: "translate(-281.977 -85)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1458",
    transform: "translate(12.92 19.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_103",
    d: "M0 0L0 0",
    className: "cls-1-gluten-free",
    transform: "translate(.08 30.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    d: "M293.239 100.174A31.243 31.243 0 0 1 302.826 99c.007 10.022-5.871 12.622-16.826 12.622a17.435 17.435 0 0 1 .59-4.8",
    className: "cls-1-gluten-free",
    transform: "translate(-263.562 -98.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    d: "M302.827 121c.006 10.021-5.873 12.621-16.827 12.621C285.993 123.6 291.871 121 302.827 121z",
    className: "cls-1-gluten-free",
    transform: "translate(-263.563 -90.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    d: "M286 122.621C285.993 112.6 291.871 110 302.827 110c.006 10.021-5.872 12.621-16.827 12.621z",
    className: "cls-1-gluten-free",
    transform: "translate(-263.563 -94.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    d: "M302 119.679c2.816 1.593 6.784 2.165 11.858 2.165 0-4.887-1.4-8-4.107-9.916",
    className: "cls-1-gluten-free",
    transform: "translate(-297.03 -93.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    d: "M302 121c10.955 0 16.834 2.6 16.827 12.621-10.955 0-16.834-2.6-16.827-12.621",
    className: "cls-1-gluten-free",
    transform: "translate(-302 -90.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_104",
    d: "M0 0L0 29",
    className: "cls-1-gluten-free",
    transform: "translate(17.08 13.995)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenFreeIcon);
export default __webpack_public_path__ + "static/media/glutenFree-Icon.a3df29ce.svg";
export { ForwardRef as ReactComponent };